import React, { useEffect, useState, useContext } from 'react'
import { Row, Col, Table } from 'react-bootstrap';
import { API } from 'api/API';
import { PAYMENTS_HISTORY } from 'config/config';
import { useParams } from 'react-router-dom';
import { FormContainer } from 'uiwidgets/FormContainer';
import { TenantContext } from '../../tenant/TenantContext';
import { evenRound } from 'util/NumberUtils';
import { formatCurrency } from 'util/Currency';
import { formatDate } from 'util/Date';
import { SecurityContext } from '../../security/SecurityContext';
import _ from "lodash";
import { useNavigate } from 'react-router-dom';
import { CancelButton } from 'uiwidgets/CancelButton';
import { Button } from 'uiwidgets/Button';
import { formatPhone } from 'util/Phone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { getPaymentStatus } from 'util/Lookup';



const PaymentHistoryDetailPage = () => {

  const { paymentId } = useParams();
  const [paymentDetail, setPaymentDetail] = useState({});
  const [payer, setPayer] = useState({});
  const { businessConfig } = useContext(TenantContext);
  const secCtx = useContext(SecurityContext);
  const navigate = useNavigate();
  const [showGwDetail, setShowGwDetail] = useState(false);
  const logoImage = process.env.REACT_APP_BASE_API_URL + "/businesses/brandelements/logo"


  useEffect(() => {
    const fetchPaymentDetail = async () => {
      let paymentDetail = await API.get(PAYMENTS_HISTORY + '/' + paymentId);
      setPaymentDetail(paymentDetail.data.payment);
      setPayer(paymentDetail.data.payer);
    }
    fetchPaymentDetail()
      .then(() => {
        console.log("Fetched payment detail");
      })
      .catch(err => {
        console.log(err);
      });
  }, []);


  return (
    <>
      {!_.isEmpty(paymentDetail) && <FormContainer title="Payment Detail">
        <Row>
          <Col mb={7} lg={7} sm={7}>
            <div>
              <img src={logoImage} alt="..." height={businessConfig.logoHeight} width={businessConfig.logoWidth} />
            </div>
          </Col>
          <Col mb={5} lg={5} sm={5} className="container d-flex justify-content-end">
            <Table size="sm" striped={false} borderless={true} className="container d-flex justify-content-end">
              <tbody>
                <tr className='m-0 p-0'><td className='m-0 p-0'>{businessConfig.name}</td></tr>
                {(businessConfig.type === 'NON_PROFIT') && <tr className='m-0 p-0'><td className='m-0 p-0'><b>Charity Number:</b> {businessConfig.charityNumber}</td></tr>}
                <tr><td className='m-0 p-0'>{businessConfig.address}</td></tr>
                <tr><td className='m-0 p-0'>{businessConfig.city}, {businessConfig.state}, {businessConfig.zip}</td></tr>
                <tr><td className='m-0 p-0'><FontAwesomeIcon icon={faPhone} /> {formatPhone(businessConfig.phoneNumber)}</td></tr>
              </tbody>
            </Table>

          </Col>
        </Row>
        <Row>&nbsp;</Row>
        <Row>&nbsp;</Row>
        <Row>
          <Col>
            <h6>Payer</h6><br />
            {payer.firstName} {payer.lastName}<br />
            {payer.address}<br />
            {payer.city}, {payer.state}, {payer.zip}<br />
            <FontAwesomeIcon icon={faPhone} /> {formatPhone(payer.mobilePhoneNumber)}<br />
            <FontAwesomeIcon icon={faEnvelope} /> {payer.email}

          </Col>
          <Col>
            <h6>Receipt Number</h6> {paymentDetail.receiptNumber}
          </Col>
          <Col>
            <h6>Payment Date</h6> {formatDate(paymentDetail.paymentDate)}
          </Col>
          <Col>
            <h6>Payment Amount</h6><h3>{formatCurrency(paymentDetail.paymentAmount / 100, businessConfig.locale, businessConfig.currency)}</h3>
            <h6>Payment Status</h6>{getPaymentStatus(paymentDetail.status)}
          </Col>
        </Row>
        <Row>
          &nbsp;
        </Row>
        <Row>
          <hr />
        </Row>

        <Row><Col>&nbsp;</Col></Row>
        <Row>
          <Col>Description</Col>
          <Col>Rate</Col>
          <Col>Quantity</Col>
          <Col>Total</Col>
          <Col>Taxes</Col>
          <Col>Total</Col>
        </Row>
        <Row><Col>&nbsp;</Col></Row>
        
        {paymentDetail.commitments.map((commitment, idx) =>( <React.Fragment key={idx}>
        <Row><Col><h6>Account: {commitment.accountTypeDisplayName}</h6></Col></Row>  
        
        {commitment.lineItems.map((lineItem, idx) => {
          let lineItemAmount = lineItem.amount;
          let lineItemQuantity = lineItem.quantity;
          let lineTotalTaxes = lineItem.taxable ? parseFloat(lineItemAmount) * parseFloat(lineItemQuantity) * parseFloat(businessConfig.salesTaxRate) : 0;
          let preTaxLineTotal = parseFloat(lineItemAmount) * parseFloat(lineItemQuantity);
          let lineItemTotal = preTaxLineTotal + lineTotalTaxes;
          return (

            <Row key={idx}>
              <Col>
                <h6>{lineItem.description}</h6>
              </Col>
              <Col>
                {formatCurrency(evenRound(lineItemAmount / 100, 2), businessConfig.locale, businessConfig.currency)}
              </Col>
              <Col>
                {lineItemQuantity}
              </Col>
              <Col>
                {formatCurrency(evenRound(preTaxLineTotal / 100, 2), businessConfig.locale, businessConfig.currency)}
              </Col>
              <Col>
                {formatCurrency(evenRound(lineTotalTaxes / 100, 2), businessConfig.locale, businessConfig.currency)}
              </Col>
              <Col>
                {formatCurrency(evenRound(lineItemTotal / 100, 2), businessConfig.locale, businessConfig.currency)}
              </Col>

            </Row>
          )
        })}
        <Row><Col>&nbsp;</Col></Row>
        </React.Fragment>))}

        {secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN") && 
        <Button label="Show/Hide Gateway Details" variant="info" className={'btn-fill pull-right'} onClick={event => { event.preventDefault(); setShowGwDetail(!showGwDetail) }} />}
        &nbsp;<CancelButton label="Go Back" onClick={(event) => { navigate(-1) }} />
        {showGwDetail && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN") &&
          <>
            <Row>
              <Col>
                &nbsp;
              </Col>
            </Row>
            <Row>
              <Col>
                <h3>Payment Gateway Detail</h3><br /><pre>{JSON.stringify(paymentDetail.gwPaymentDetails, null, 2)}</pre>
              </Col>
            </Row>
          </>}
      </FormContainer>}
    </>

  )
}

export default PaymentHistoryDetailPage